export const GET_NBVISITE_REQUEST = "GET_NBVISITE_REQUEST";
export const GET_NBVISITE_SUCCESS = "GET_NBVISITE_SUCCESS";
export const GET_NBVISITE_ERROR = "GET_NBVISITE_ERROR";

export const GET_TOP3CATEG_REQUEST = "GET_TOP3CATEG_REQUEST";
export const GET_TOP3CATEG_SUCCESS = "GET_TOP3CATEG_SUCCESS";
export const GET_TOP3CATEG_ERROR = "GET_TOP3CATEG_ERROR";

export const GET_RESETSTATSMONTHLY_REQUEST = "GET_RESETSTATSMONTHLY_REQUEST";
export const GET_RESETSTATSMONTHLY_SUCCESS = "GET_RESETSTATSMONTHLY_SUCCESS";
export const GET_RESETSTATSMONTHLY_ERROR = "GET_RESETSTATSMONTHLY_ERROR";

export const GET_ARRAYVISITEYEARS_REQUEST = "GET_ARRAYVISITEYEARS_REQUEST";
export const GET_ARRAYVISITEYEARS_SUCCESS = "GET_ARRAYVISITEYEARS_SUCCESS";
export const GET_ARRAYVISITEYEARS_ERROR = "GET_ARRAYVISITEYEARS_ERROR";

export const getNbVisiteRequest = (payload) => ({
  type: GET_NBVISITE_REQUEST,
  payload,
});
export const getNbVisiteSuccess = (nbVisite) => ({
  type: GET_NBVISITE_SUCCESS,
  nbVisite,
});
export const getNbVisiteError = (error) => ({
  type: GET_NBVISITE_ERROR,
  error,
});

export const getTop3CategoryVisitedRequest = (payload) => ({
  type: GET_TOP3CATEG_REQUEST,
  payload,
});

export const getTop3CategoryVisitedSuccess = (top3Categ) => ({
  type: GET_TOP3CATEG_SUCCESS,
  top3Categ,
});

export const getTop3CategoryVisitedError = (error) => ({
  type: GET_TOP3CATEG_ERROR,
  error,
});

export const resetStatsMonthlyRequest = (payload) => ({
  type: GET_RESETSTATSMONTHLY_REQUEST,
  payload,
});

export const resetStatsMonthlySuccess = () => ({
  type: GET_RESETSTATSMONTHLY_SUCCESS,
});

export const resetStatsMonthlyError = (error) => ({
  type: GET_RESETSTATSMONTHLY_ERROR,
  error,
});

export const getArrayVisiteYearsRequest = (payload) => ({
  type: GET_ARRAYVISITEYEARS_REQUEST,
  payload,
});

export const getArrayVisiteYearsSuccess = (arrayVisiteYears) => ({
  type: GET_ARRAYVISITEYEARS_SUCCESS,
  arrayVisiteYears,
});

export const getArrayVisiteYearsError = (error) => ({
  type: GET_ARRAYVISITEYEARS_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/admin/stats/actions.js